import { inject, observer } from "mobx-react";
import * as React from "react";
import { DocumentSearch } from "../Reader/DocumentSearch";
import { AppStore } from "../Stores/AppStore";
import { DocumentFilterClean } from "../Stores/DocumentFilterStore";
import { DocumentStoreImpl } from "../Stores/DocumentStore";

interface ISelectDocumentDialog {
	updateConfirmButton: () => void;
	documentStore?: DocumentStoreImpl;
}

@inject('documentStore')
@observer
export class SelectDocumentDialog extends React.Component<ISelectDocumentDialog, {}> {

	isShiftDown: boolean;
	isCtrlDown: boolean;
	docs: string[];
	lastId: string;

	componentWillMount() {
		window.addEventListener("keydown", this.onKeyDown.bind(this));
		window.addEventListener("keyup", this.onKeyUp.bind(this));
		this.props.updateConfirmButton();
	}

	componentWillUnmount() {
		window.removeEventListener("keydown", this.onKeyDown.bind(this));
		window.removeEventListener("keyup", this.onKeyUp.bind(this));
	}

	onKeyDown = (event: React.KeyboardEvent) => {
		if (event.shiftKey) {
			this.isShiftDown = true;
		}
		if (event.ctrlKey) {
			this.isCtrlDown = true;
		}
	}

	onKeyUp = (event: React.KeyboardEvent) => {
		if (!event.shiftKey) {
			this.isShiftDown = false;
		}
		if (!event.ctrlKey) {
			this.isCtrlDown = false;
		}
	}

	updateSearchResult = (ids: string[]) => {
		this.docs = ids;
	}

	onSelectDocument = (id: string) => {
		if (this.isShiftDown && this.props.documentStore.isDocumentLinkMultiple) {
			this.props.documentStore.addedDocuments.clear();
			this.idsSinceLastClick(id).forEach(idSinceLast => {
				if (!this.props.documentStore.addedDocuments.some(d => d === idSinceLast)) {
					this.props.documentStore.addedDocuments.push(idSinceLast)
				}
			});
		}
		else if (this.isCtrlDown && this.props.documentStore.isDocumentLinkMultiple) {
			if (!this.props.documentStore.addedDocuments.remove(id)) {
				this.props.documentStore.addedDocuments.push(id);
			}
			this.lastId = id;
		}
		else {
			this.props.documentStore.addedDocuments.clear();
			this.props.documentStore.addedDocuments.push(id);
			this.lastId = id;
		}
		this.props.updateConfirmButton();
	}

	idsSinceLastClick(id: string) {
		let start = this.docs.indexOf(this.lastId);
		let end = this.docs.indexOf(id);
		if (start > -1 && end > -1) {
			if (end > start) {
				return this.docs.slice(start, end + 1);
			}
			else {
				return this.docs.slice(end, start + 1);
			}
		}
		return [];
	}

	render() {
		return <div className="wizardbox-content">
			<div className="wizardbox-module">
				<DocumentSearch history={AppStore.history}
					location={AppStore.history.location}
					match={null}
					onDocumentClick={this.onSelectDocument}
					isSelected={(id) => this.props.documentStore.addedDocuments.some(doc => doc === id)}
					currentDocument={this.props.documentStore.model.guid}
					isShiftKey={this.isShiftDown}
					updateSearchResult={this.updateSearchResult}
					store={new DocumentFilterClean()} />
			</div>
		</div>;
	}
}